export class GetInternalDocumentsRequest {
    public key: string = "getInternalDocuments"

    constructor() {}
}
